interface DisabledTextInputProps {
  id: string;
  label?: string;
  labelColour?: string;
  className: string;
  ariaLabel?: string;
  showLabel?: boolean;
  value: string;
}

export default function DisabledTextInput({
  id,
  label,
  labelColour,
  className,
  ariaLabel,
  showLabel,
  value,
}: DisabledTextInputProps) {
  return (
    <div>
      {showLabel ? (
        <label
          htmlFor={id}
          className={`mb-3 block text-left text-sm font-medium ${labelColour}`}
        >
          {label}
        </label>
      ) : (
        <label
          htmlFor={id}
          className={`mb-3 block text-left text-sm font-medium ${labelColour}`}
        />
      )}
      <input
        id={id}
        type="text"
        className={className}
        aria-label={ariaLabel}
        required={false}
        value={value}
        disabled
      />
    </div>
  );
}

DisabledTextInput.defaultProps = {
  labelColour: "text-black",
  ariaLabel: "",
  showLabel: false,
};
